import * as React from "react";
import Link from "next/link";
import { ChevronRight } from "lucide-react";
export interface LinkItem {
  text: string;
  slug: string;
}
interface LinkButtonProps {
  baseUrl?: string;
  links: LinkItem[];
}
const LinkButtonArray: React.FC<LinkButtonProps> = ({
  links,
  baseUrl
}) => {
  return <div className="flex flex-col gap-4" data-sentry-component="LinkButtonArray" data-sentry-source-file="LinkButtonArray.tsx">
      {links.map((item, index) => {
      const newPath = baseUrl ? `${baseUrl}/${item.slug}` : item.slug;
      return <Link key={index} href={newPath} passHref>
            <button className="inline-flex w-full items-center justify-between gap-10 rounded-3xl bg-glow/90 p-4 text-base text-primary-foreground backdrop-blur-md transition hover:bg-glow/75 active:scale-95">
              <span className="text-left">{item.text}</span>
              <ChevronRight size={20} />
            </button>
          </Link>;
    })}
    </div>;
};
export default LinkButtonArray;